import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause ",
  "use": "icon-pause -usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause \"><defs><style></style></defs><path d=\"M256 810.667h170.667V213.333H256v597.334zm341.333-597.334v597.334H768V213.333H597.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol